import React from 'react';

export const OutlookCalendarSVG = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <rect width="20" height="20" rx="4" fill="white" />
        <path
            d="M17.1665 10.3333C17.1669 10.2782 17.1531 10.2239 17.1263 10.1757C17.0996 10.1276 17.0608 10.0871 17.0139 10.0583H17.0122L17.0062 10.055L12.0395 7.11496C12.0181 7.10047 11.9958 7.08723 11.9729 7.0753C11.8784 7.02654 11.7736 7.0011 11.6672 7.0011C11.5609 7.0011 11.456 7.02654 11.3615 7.0753C11.3386 7.08723 11.3163 7.10048 11.2949 7.11496L6.32822 10.055L6.32222 10.0583C6.17043 10.1527 6.12389 10.3523 6.21829 10.5041C6.2461 10.5488 6.28441 10.5861 6.32989 10.6126L11.2965 13.5526C11.3181 13.567 11.3403 13.5802 11.3632 13.5923C11.4577 13.641 11.5625 13.6665 11.6689 13.6665C11.7752 13.6665 11.88 13.641 11.9746 13.5923C11.9974 13.5802 12.0197 13.567 12.0412 13.5526L17.0079 10.6126C17.0566 10.5842 17.097 10.5434 17.1248 10.4943C17.1527 10.4453 17.1671 10.3897 17.1665 10.3333Z"
            fill="#0A2767"
        />
        <path
            d="M6.90717 8.37037H10.1665V11.358H6.90717V8.37037ZM16.4998 5.33337V3.9667C16.5077 3.62501 16.2372 3.34156 15.8955 3.33337H7.43751C7.09581 3.34156 6.82535 3.62501 6.83317 3.9667V5.33337L11.8332 6.6667L16.4998 5.33337Z"
            fill="#0364B8"
        />
        <path
            d="M6.8335 5.33337H10.1668V8.33337H6.8335V5.33337Z"
            fill="#0078D4"
        />
        <path
            d="M13.4998 5.33337H10.1665V8.33337L13.4998 11.3334H16.4998V8.33337L13.4998 5.33337Z"
            fill="#28A8EA"
        />
        <path
            d="M10.1665 8.33337H13.4998V11.3334H10.1665V8.33337Z"
            fill="#0078D4"
        />
        <path
            d="M10.1665 11.3334H13.4998V14.3334H10.1665V11.3334Z"
            fill="#0364B8"
        />
        <path
            d="M6.90723 11.358H10.1666V14.074H6.90723V11.358Z"
            fill="#14447D"
        />
        <path d="M13.5 11.3334H16.5V14.3334H13.5V11.3334Z" fill="#0078D4" />
        <path
            d="M17.0138 10.5944L17.0075 10.5977L12.0408 13.391C12.0192 13.4044 11.9972 13.417 11.9742 13.4284C11.8898 13.4685 11.7982 13.4912 11.7048 13.495L11.4335 13.3364C11.4106 13.3249 11.3883 13.3121 11.3668 13.298L6.3335 10.4254H6.33117L6.1665 10.3334V15.988C6.16907 16.3653 6.4769 16.6691 6.85417 16.6667H16.4895C16.4952 16.6667 16.5002 16.664 16.5062 16.664C16.5858 16.6589 16.6644 16.6425 16.7395 16.6154C16.7719 16.6016 16.8032 16.5853 16.8331 16.5667C16.8555 16.554 16.8938 16.5264 16.8938 16.5264C16.978 16.4641 17.0465 16.3829 17.0939 16.2895C17.1412 16.196 17.1661 16.0928 17.1665 15.988V10.3334C17.1664 10.3865 17.1523 10.4387 17.1254 10.4845C17.0986 10.5304 17.0601 10.5683 17.0138 10.5944Z"
            fill="url(#paint0_linear_114_6890)"
        />
        <path
            opacity="0.5"
            d="M16.9001 10.3109V10.6576L11.7068 14.2333L6.33016 10.4276C6.33016 10.4267 6.32981 10.4259 6.32918 10.4252C6.32856 10.4246 6.32771 10.4243 6.32683 10.4243L5.8335 10.1276V9.8776L6.03683 9.87427L6.46683 10.1209L6.47682 10.1243L6.51349 10.1476C6.51349 10.1476 11.5668 13.0309 11.5801 13.0376L11.7735 13.1509C11.7901 13.1443 11.8068 13.1376 11.8268 13.1309C11.8368 13.1243 16.8435 10.3076 16.8435 10.3076L16.9001 10.3109Z"
            fill="#0A2767"
        />
        <path
            d="M17.0138 10.5944L17.0075 10.598L12.0408 13.3914C12.0192 13.4047 11.9972 13.4174 11.9742 13.4287C11.879 13.4752 11.7744 13.4994 11.6685 13.4994C11.5625 13.4994 11.458 13.4752 11.3628 13.4287C11.34 13.4174 11.3177 13.4049 11.2961 13.3914L6.3295 10.598L6.32351 10.5944C6.27642 10.5688 6.23703 10.5312 6.20942 10.4853C6.18181 10.4394 6.16699 10.3869 6.1665 10.3334V15.988C6.16889 16.3652 6.47661 16.6691 6.85381 16.6667H16.4792C16.8564 16.6691 17.1641 16.3653 17.1665 15.9881C17.1665 15.9881 17.1665 15.9881 17.1665 15.9881V10.3334C17.1664 10.3865 17.1523 10.4387 17.1254 10.4845C17.0986 10.5304 17.0601 10.5683 17.0138 10.5944Z"
            fill="#1490DF"
        />
        <path
            opacity="0.1"
            d="M12.1134 13.35L12.0391 13.3916C12.0176 13.4054 11.9953 13.4179 11.9724 13.4293C11.8906 13.4695 11.8015 13.4931 11.7104 13.4986L13.6001 15.7333L16.8964 16.5276C16.9868 16.4594 17.0586 16.3697 17.1054 16.2666L12.1134 13.35Z"
            fill="black"
        />
        <path
            opacity="0.05"
            d="M12.4501 13.1606L12.0391 13.3916C12.0176 13.4054 11.9953 13.4179 11.9724 13.4293C11.8906 13.4695 11.8015 13.4931 11.7104 13.4986L12.5958 15.9396L16.8974 16.5266C16.981 16.4639 17.0489 16.3825 17.0956 16.2891C17.1424 16.1956 17.1667 16.0925 17.1668 15.988V15.915L12.4501 13.1606Z"
            fill="black"
        />
        <path
            d="M6.86317 16.6667H16.4782C16.6261 16.6674 16.7704 16.6207 16.8898 16.5334L11.4332 13.337C11.4102 13.3255 11.388 13.3127 11.3665 13.2987L6.33317 10.426H6.33083L6.1665 10.3334V15.9687C6.16613 16.3538 6.47803 16.6663 6.86317 16.6667C6.86316 16.6667 6.86316 16.6667 6.86317 16.6667Z"
            fill="#28A8EA"
        />
        <path
            opacity="0.1"
            d="M10.8332 6.611V13.721C10.8326 13.9703 10.681 14.1943 10.4498 14.2877C10.3782 14.3184 10.3011 14.3343 10.2232 14.3343H6.1665V6.33333H6.83317V6H10.2232C10.5599 6.00128 10.8324 6.27425 10.8332 6.611Z"
            fill="black"
        />
        <path
            opacity="0.2"
            d="M10.4998 6.94428V14.0543C10.5007 14.1348 10.4836 14.2145 10.4498 14.2876C10.3573 14.5158 10.1361 14.6655 9.88983 14.6666H6.1665V6.33328H9.88983C9.98655 6.33231 10.0819 6.35643 10.1665 6.40328C10.3708 6.50623 10.4998 6.71548 10.4998 6.94428Z"
            fill="black"
        />
        <path
            opacity="0.2"
            d="M10.4998 6.94428V13.3876C10.4982 13.7242 10.2264 13.997 9.88984 13.9999H6.1665V6.33328H9.88983C9.98655 6.33231 10.0819 6.35643 10.1665 6.40328C10.3708 6.50623 10.4998 6.71548 10.4998 6.94428Z"
            fill="black"
        />
        <path
            opacity="0.2"
            d="M10.1665 6.94437V13.3877C10.1661 13.7248 9.89361 13.9984 9.5565 14H6.1665V6.33337H9.5565C9.89357 6.33355 10.1667 6.60696 10.1665 6.94404C10.1665 6.94415 10.1665 6.94426 10.1665 6.94437Z"
            fill="black"
        />
        <path
            d="M3.44449 6.33337H9.55582C9.89327 6.33337 10.1668 6.60693 10.1668 6.94437V13.0557C10.1668 13.3931 9.89327 13.6667 9.55582 13.6667H3.44449C3.10705 13.6667 2.8335 13.3931 2.8335 13.0557V6.94437C2.8335 6.60693 3.10705 6.33337 3.44449 6.33337Z"
            fill="url(#paint1_linear_114_6890)"
        />
        <path
            d="M4.74277 8.89594C4.89335 8.57509 5.13643 8.3066 5.44077 8.12494C5.77781 7.93198 6.16156 7.83578 6.54977 7.84694C6.90957 7.83914 7.26461 7.93034 7.5761 8.1106C7.86897 8.28526 8.10484 8.54116 8.2551 8.84727C8.41873 9.18457 8.50028 9.55578 8.4931 9.9306C8.50103 10.3223 8.41713 10.7105 8.2481 11.0639C8.09427 11.381 7.85091 11.646 7.5481 11.8263C7.2246 12.012 6.85639 12.1057 6.48344 12.0969C6.11595 12.1058 5.75308 12.0136 5.43444 11.8303C5.13903 11.6554 4.9002 11.3992 4.74644 11.0923C4.58184 10.7598 4.49931 10.3928 4.50577 10.0219C4.49892 9.63354 4.57993 9.24862 4.74277 8.89594ZM5.48677 10.7059C5.56706 10.9088 5.70321 11.0847 5.87943 11.2133C6.05892 11.3387 6.27385 11.4034 6.49276 11.3979C6.7259 11.4072 6.9557 11.3402 7.14743 11.2073C7.32142 11.0791 7.454 10.9027 7.52876 10.6999C7.61234 10.4735 7.65358 10.2336 7.65043 9.99227C7.65301 9.74861 7.61424 9.50629 7.53576 9.2756C7.46644 9.06733 7.33814 8.88367 7.16643 8.74694C6.9795 8.60768 6.75031 8.53705 6.51743 8.54694C6.29377 8.54115 6.07403 8.60638 5.88976 8.73327C5.71056 8.8624 5.57182 9.03987 5.48976 9.24493C5.30773 9.71498 5.30678 10.2359 5.48709 10.7066L5.48677 10.7059Z"
            fill="white"
        />
        <path d="M13.5 5.33337H16.5V8.33337H13.5V5.33337Z" fill="#50D9FF" />
        <defs>
            <linearGradient
                id="paint0_linear_114_6890"
                x1="11.6665"
                y1="10.3334"
                x2="11.6665"
                y2="16.6667"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#35B8F1" />
                <stop offset="1" stopColor="#28A8EA" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_114_6890"
                x1="4.10744"
                y1="5.85595"
                x2="8.89287"
                y2="14.1441"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#1784D9" />
                <stop offset="0.5" stopColor="#107AD5" />
                <stop offset="1" stopColor="#0A63C9" />
            </linearGradient>
        </defs>
    </svg>
);

OutlookCalendarSVG.displayName = 'OutlookCalendarSVG';
